
import { useTheme as useThemeContext } from "@/context/theme-provider";

export function useTheme() {
  return useThemeContext();
}
